module.exports = __webpack_public_path__ + "img/plus.002e6cf3.svg";